export interface IDropdownOption {
    text?: string;
    value?: string;
    isSelected?: boolean;
    isHeader?: boolean;
    name?: string;
    key?: string;
    isDisabled?: boolean;
}

export interface IDropdown {
    label?: string;
    name?: string;
    options?: IDropdownOption[];
    className?: string;
    isDisabled?: boolean;
    addOthersOption?: boolean;
    addSelectOption?: boolean;
}

export interface IDropdownEventType {
    name: string;
    value: string;
    text?: string;
    previousSelectedValue?: string;
}

export class DropdownOption implements IDropdownOption {
    text: string;
    value: string;
    isSelected?: boolean;
    isHeader?: boolean;
    name?: string;
    key?: string;
    isDisabled?: boolean;

    constructor(dropdownOption?: IDropdownOption) {
        if(dropdownOption)
        {
            this.text = dropdownOption.text;
        this.value = dropdownOption.value;

        if (dropdownOption.isSelected) {
            this.isSelected = dropdownOption.isSelected;
        }
        if (dropdownOption.isHeader) {
            this.isHeader = dropdownOption.isHeader;
        }
        if (dropdownOption.name) {
            this.name = dropdownOption.name;
        }
        if (dropdownOption.key) {
            this.key = dropdownOption.key;
        }
        if (dropdownOption.isDisabled) {
            this.isDisabled = dropdownOption.isDisabled;
        }
        }
    }
}


export class Dropdown implements IDropdown {
    label?: string;
    name?: string;
    image?: string;
    options?: IDropdownOption[];
    className?: string;
    addOthersOption?: boolean = true;
    addSelectOption?: boolean = true;
    constructor(dropdown?: IDropdown) {
        if (dropdown) {
            this.label = dropdown.label;
            this.name = dropdown.name;
            this.options = dropdown.options;
            this.className = dropdown.className;
            this.addOthersOption= dropdown.addOthersOption;
            this.addSelectOption=dropdown.addSelectOption;
        } else {
            this.options = [];
        }
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/components/dropdown/dropdown-model.ts